import compose from 'lodash/flowRight'
import { connect } from 'react-redux'

import { canAssignOrdersToNewConnections } from 'store/currentUser/selectors'
import {
  changeRetailerContactEmail,
  changeRetailerId,
  changeRetailerSearchText,
  setSelectedRetailerId,
} from 'store/orderList/assignRetailerAccountModal/actions'
import {
  getRetailerContactEmail,
  getRetailerIds,
  getRetailerSearchText,
  getSelectedRetailerId,
} from 'store/orderList/assignRetailerAccountModal/selectors'

import { withAnalytics } from './AssignRetailerAccountModal.analytics'
import AssignRetailerAccountModal from './AssignRetailerAccountModal.component'
import withUpdateOrderRetailerAccountMutation from './AssignRetailerAccountModal.mutations'
import { withConnectedRetailers } from './AssignRetailerAccountModal.queries'

const mapStateToProps = (state) => ({
  selectedRetailerId: getSelectedRetailerId(state),
  retailerContactEmail: getRetailerContactEmail(state),
  retailerIds: getRetailerIds(state),
  retailerSearchText: getRetailerSearchText(state),
  canAssignOrdersToNewConnections: canAssignOrdersToNewConnections(state),
})

const mapDispatchToProps = {
  setSelectedRetailerId: (retailerId) => setSelectedRetailerId(retailerId),
  changeRetailerContactEmail: (contactEmail) =>
    changeRetailerContactEmail(contactEmail),
  changeRetailerId,
  changeRetailerSearchText: (searchText) =>
    changeRetailerSearchText(searchText),
}

export const withRedux = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withRedux,
  withConnectedRetailers,
  withUpdateOrderRetailerAccountMutation,
  withAnalytics,
)(AssignRetailerAccountModal)
